import { EmailJourney } from './email-journey'
import { EnvelopeFloat } from './envelope-float'

export function Hero() {
  return (
    <section
      className="grid-hero section-pad"
      style={{
        maxWidth: 1300, margin: '0 auto',
        paddingTop: 80, paddingBottom: 60,
        gap: 60,
        alignItems: 'center', position: 'relative',
        minHeight: '85vh',
      }}
    >
      {/* Decorative blobs — hidden on mobile */}
      <div className="desktop-only">
        <div
          style={{
            position: 'absolute', top: -40, right: 80, width: 300, height: 300,
            background: 'linear-gradient(135deg, #FFE4CC, #FFDAB3)',
            animation: 'oe-blob 8s ease-in-out infinite',
            opacity: 0.5, filter: 'blur(40px)', pointerEvents: 'none',
          }}
        />
        <div
          style={{
            position: 'absolute', bottom: 40, left: -60, width: 200, height: 200,
            background: 'linear-gradient(135deg, #FF6B00, #FF9E4F)',
            animation: 'oe-blob 10s ease-in-out 2s infinite',
            opacity: 0.15, filter: 'blur(50px)', pointerEvents: 'none',
          }}
        />
      </div>

      {/* Floating envelopes — hidden on mobile */}
      <div className="desktop-only">
        <EnvelopeFloat style={{ top: '10%', right: '15%' }} delay={0} />
        <EnvelopeFloat style={{ top: '60%', right: '5%' }} delay={2} />
        <EnvelopeFloat style={{ top: '30%', left: '45%' }} delay={4} />
      </div>

      {/* Left — Copy */}
      <div style={{ position: 'relative', zIndex: 2 }}>
        <div
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            background: '#fff', borderRadius: 100, padding: '8px 18px 8px 10px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
            marginBottom: 32, fontSize: 13, fontWeight: 600, color: '#666',
          }}
        >
          <span
            style={{
              background: '#d45a00', color: '#fff', padding: '3px 10px',
              borderRadius: 100, fontSize: 11, fontWeight: 800, letterSpacing: '0.04em',
            }}
          >
            COMING SOON
          </span>
          Join the waitlist for early access
        </div>

        <h1
          style={{
            fontSize: 'clamp(52px, 5.5vw, 76px)', fontWeight: 800,
            lineHeight: 1.0, letterSpacing: '-0.04em', marginBottom: 24,
          }}
        >
          Email platform
          <br />
          for people
          <br />
          who{' '}
          <span
            style={{
              fontFamily: "var(--oe-font-serif)", fontStyle: 'italic',
              fontWeight: 400, color: '#FF6B00', position: 'relative',
            }}
          >
            hate
            <svg
              viewBox="0 0 200 12"
              aria-hidden="true"
              style={{ position: 'absolute', bottom: -6, left: 0, width: '100%', height: 12 }}
            >
              <path d="M0 6 Q50 0, 100 6 Q150 12, 200 6" stroke="#FF6B00" strokeWidth="3" fill="none" opacity="0.5" />
            </svg>
          </span>{' '}
          overpaying
        </h1>

        <p
          style={{
            fontSize: 19, lineHeight: 1.65, color: '#5a5452',
            maxWidth: 460, marginBottom: 40,
          }}
        >
          Your emails. Our servers.
          <br />
          Free for 10,000 emails/month. Paid plans from $5.
        </p>

        <div
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: 'rgba(255,107,0,0.08)', borderRadius: 10,
            padding: '12px 20px', fontSize: 15, fontWeight: 700, color: '#d45a00',
          }}
        >
          Coming soon
        </div>
      </div>

      {/* Right — Getting started checklist */}
      <EmailJourney />
    </section>
  )
}
